import React from 'react'
import Box from '@material-ui/core/Box'
import CurrentUserDisplay from '../../components/current-user-display'
import PageHeading from '../../components/page-heading'
import AnonymousView from './anonymous-view'
import AuthenticatedView from './authenticated-view'

const LandingPage = () => {
  return (
    <Box mb={2}>
      <CurrentUserDisplay
        fallback={(
          <>
            <PageHeading
              heading="Create your MyPGA Account"
              subheading="Please enter the account owner’s details below. If you are registering a family member, their information will be entered at a later step in the process."
            />
            <AnonymousView />
          </>
        )}
      >
        {({ currentUser }) => (
          <>
            <PageHeading
              heading="MyPGA Account"
              subheading="Please enter the account owner’s details below. If you are registering a family member, their information will be entered at a later step in the process."
            />
            <AuthenticatedView currentUser={currentUser} />
          </>
        )}
      </CurrentUserDisplay>
    </Box>
  )
}

export default LandingPage
